'use client';
import { useState, useEffect, useCallback } from 'react';
import { trackEvent } from '@/lib/telemetry';

const STORAGE_KEY = 'bpb_part_order';

// Volgorde van parts binnen een zak: 'color' (licht→donker, backend-volgorde)
// of 'type' (Bricks/Slopes/Plates/... met kopjes, per maat - lib/partTypes).
// Eén voorkeur per bezoeker, gedeeld door setpagina en sort mode en geldig
// voor alle sets: het hangt af van hoe iemand zijn stenen opslaat.
export function usePartOrder(source) {
  const [partOrder, setPartOrder] = useState('color');
  useEffect(() => {
    try {
      const stored = localStorage.getItem(STORAGE_KEY);
      if (stored === 'type' || stored === 'color') setPartOrder(stored);
    } catch (e) { /* localStorage unavailable */ }
  }, []);
  const changePartOrder = useCallback((value) => {
    setPartOrder(value);
    try { localStorage.setItem(STORAGE_KEY, value); } catch (e) { /* localStorage unavailable */ }
    trackEvent('Part Order Changed', { order: value, source });
  }, [source]);
  return [partOrder, changePartOrder];
}
